
import axiosInstance from "api/axiosInstance";
import { toast } from "react-toastify";
import { showToast } from "toast/toastHelper";
export const createPlan = async ({ accessToken, name, price, days, tokens, files, fileSize, userLimit, active, promptTokens
  , off, tokenLimit, messagePerDay, userTokens, fileTokens, gptMaxTokens, charLimit, isFeatured, permissions, bots, platformPercent, ragSlots,
  ragTokens,
}) => {

  try {
    const response = await axiosInstance.post("/admin/plans/create", {
      name, price, days, tokens, files, fileSize, userLimit, promptTokens
      , active, tokenLimit, messagePerDay, off, userTokens, fileTokens, gptMaxTokens, charLimit, isFeatured, permissions, bots, platformPercent, ragSlots,
      ragTokens,
    }, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  } catch (error) {
    console.log("error--> ", error)
    showToast(error?.response?.data?.error, "error");
    if (error.response) {
      const status = error.response.status;
      if (status === 403) {
        console.warn(
          "خطای 403: دسترسی غیرمجاز، کاربر به صفحه ورود هدایت می‌شود."
        );
        window.location.href = "/login";
        return;
      }
      throw {
        statusCode: status,
        message:
          error.response.data?.error || "خطای ناشناخته   ",
      };
    } else {
      throw { statusCode: 500, message: "مشکل شبکه یا عدم دسترسی به سرور" };
    }
  }
};

export const planList = async (accessToken) => {
  try {
    const response = await axiosInstance.get("/admin/plans/list", {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      const status = error.response.status;
      if (status == 403) {
        console.warn(
          "خطای 403: دسترسی غیرمجاز، کاربر به صفحه ورود هدایت می‌شود."
        );
        window.location.href = "/login";
        return;
      }
      throw {
        statusCode: status,
        message:
          error.response.data?.message || "خطای ناشناخته   ",
      };
    } else {
      throw { statusCode: 500, message: "مشکل شبکه یا عدم دسترسی به سرور" };
    }
  }
};
export const editPlan = async ({ accessToken, id, name, price, days, tokens, files, fileSize, userLimit, active, off, messagePerDay, userTokens, fileTokens, gptMaxTokens, promptTokens, charLimit, isFeatured, permissions, bots, platformPercent, ragSlots, ragTokens }) => {
  try {
    const response = await axiosInstance.patch("/admin/plans/edit", { id, name, price, days, tokens, files, fileSize, userLimit, active, off, messagePerDay, userTokens, fileTokens, gptMaxTokens, promptTokens, charLimit, isFeatured, permissions, bots, platformPercent, ragSlots, ragTokens }, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      const status = error.response.status;
      if (status === 403) {
        console.warn(
          "خطای 403: دسترسی غیرمجاز، کاربر به صفحه ورود هدایت می‌شود."
        );
        window.location.href = "/login";
        return;
      }
      throw {
        statusCode: status,
        message:
          error.response.data?.error || "خطای ناشناخته   ",
      };
    } else {
      throw { statusCode: 500, message: "مشکل شبکه یا عدم دسترسی به سرور" };
    }
  }
};

export const userPlansList = async (accessToken) => {
  try {
    const response = await axiosInstance.get("/admin/subscriptions/all", {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      const status = error.response.status;
      if (status == 403) {
        console.warn(
          "خطای 403: دسترسی غیرمجاز، کاربر به صفحه ورود هدایت می‌شود."
        );
        window.location.href = "/login";
        return;
      }
      throw {
        statusCode: status,
        message:
          error.response.data?.message || "خطای ناشناخته   ",
      };
    } else {
      throw { statusCode: 500, message: "مشکل شبکه یا عدم دسترسی به سرور" };
    }
  }
};


export const getPermsList = async (accessToken) => {
  try {
    const response = await axiosInstance.get("/admin/perms/list", {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      withCredentials: true,
    });
    return response.data;
  } catch (error) {

    if (error.response) {
      const status = error.response.status;
      const errorMessage = error.response.data?.error || error?.message;
      if (errorMessage) toast.error(errorMessage);
      else toast.error("مشکل شبکه یا عدم دسترسی به سرور.");

    } else {
      // خطاهای مربوط به شبکه یا سرور
      toast.error("مشکل شبکه یا عدم دسترسی به سرور.");
    }
  }
};
